import React from 'react';

/** 分数（絶対値）→ H:MM 文字列 */
export function minutesToHMM(value: number, isNegative: boolean): string {
  const totalMinutes = Math.round(Math.abs(value));
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const sign = isNegative ? '-' : '';
  return `${sign}${hours}:${minutes.toString().padStart(2, '0')}`;
}

/** レイヤースライド用の時刻表示ノード（親の time-pouch 有無に依存しない見た目） */
export function layerTimeDisplayNode(
  value: number,
  isNegative: boolean,
  tag: 'strong' | 'span' = 'span',
): React.ReactElement {
  const text = minutesToHMM(value, isNegative);
  const style = isNegative ? { color: 'var(--negative-color)' } : undefined;
  const className = 'layer-time-display';
  if (tag === 'strong') {
    return (
      <strong className={className} style={style}>
        {text}
      </strong>
    );
  }
  return (
    <span className={className} style={style}>
      {text}
    </span>
  );
}
